module.exports = __webpack_public_path__ + "static/media/chartSVG.14e6f0f3.svg";